import React, { useEffect, useState } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { Fade } from "react-reveal"
import getPreview from "../components/getPreview"

function CustomSolutions() {
  const [previewData, setPreviewData] = useState(null)
  const data = useStaticQuery(graphql`
    query CustomSolutionsQuery {
      section1: file(relativePath: { eq: "cus-sol-1.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      section2: file(relativePath: { eq: "cus-sol-2.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      section3: file(relativePath: { eq: "cus-sol-3.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      customSolutionsBg: file(relativePath: { eq: "process-bg.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      section1Bg: file(relativePath: { eq: "section-bg.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      section2Bg: file(relativePath: { eq: "section-2-bg.jpg" }) {
        childImageSharp {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wpgraphql {
        pages(where: { id: 6 }) {
          edges {
            node {
              seo {
                title
                metaDesc
              }
              title
              subtitle {
                subtitle
              }
              content
              closingHeader {
                header
                subheader
              }
              customSolutions {
                topImages {
                  id
                  sourceUrl
                  imageFile {
                    childImageSharp {
                      fluid {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }
                }
                closingContent
                sections {
                  content
                  image {
                    sourceUrl
                    imageFile {
                      childImageSharp {
                        fluid {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  link {
                    title
                    url
                  }
                  title
                }
              }
            }
          }
        }
      }
    }
  `)
  useEffect(() => {
    getPreview(`query MyQuery {
      pages(where: { id: 6 }) {
        nodes {
          revisions {
             nodes {
              seo {
                title
                metaDesc
              }
              title
              subtitle {
                subtitle
              }
              content
              closingHeader {
                header
                subheader
              }
              customSolutions {
                topImages {
                  id
                  sourceUrl
                  
                }
                closingContent
                sections {
                  content
                  image {
                    sourceUrl
                    
                  }
                  link {
                    title
                    url
                  }
                  title
                }
              }
            }
          }
        }
    }
}`).then(preview => preview && setPreviewData(preview))
  }, [])
  const { seo } = previewData || data.wpgraphql.pages.edges[0].node
  const pageTitle =
    (previewData && previewData.title) ||
    data.wpgraphql.pages.edges[0].node.title
  const pageSubtitle =
    (previewData && previewData.subtitle.subtitle) ||
    data.wpgraphql.pages.edges[0].node.subtitle.subtitle
  const customSolutionsData =
    (previewData && previewData.customSolutions.sections) ||
    data.wpgraphql.pages.edges[0].node.customSolutions.sections
  const { content, closingHeader } =
    previewData || data.wpgraphql.pages.edges[0].node
  const { closingContent, topImages } =
    (previewData && previewData.customSolutions) ||
    data.wpgraphql.pages.edges[0].node.customSolutions
  const {
    section1,
    section2,
    section3,
    section1Bg,
    section2Bg,
    customSolutionsBg,
  } = data
  return (
    <Layout content={content} pageSubtitle={pageSubtitle} pageTitle={pageTitle}>
      <SEO description={seo.metaDesc} title={seo.title} />
      <section class="content-container custom-solutions">
        <Img
          className="bg-image-fit"
          fluid={customSolutionsBg.childImageSharp.fluid}
        />

        <div class="repeatable-section-container-container">
          <div class="repeatable-section-title-container">
            <svg
              class="repeatable-section-rectangle"
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="159"
              viewBox="0 0 23 159"
            >
              <rect class="cls-1" width="23" height="159" />
            </svg>
            <h2>{customSolutionsData[0].title}</h2>
            <svg
              class="repeatable-section-title-shape"
              xmlns="http://www.w3.org/2000/svg"
              width="91"
              height="8"
              viewBox="0 0 91 8"
            >
              <path
                id="Rectangle_4_copy_13"
                data-name="Rectangle 4 copy 13"
                class="cls-1"
                d="M410,1912h1v8h-1v-8Zm5,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm-50-2h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm5-3h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm45-3h1v8h-1v-8Zm5,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm-50-2h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm5-3h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Z"
                transform="translate(-370 -1912)"
              />
            </svg>
          </div>
          <div class="repeatable-section-container">
            <div>
              <div class="repeatable-image-container">
                {previewData ? (
                  <img src={customSolutionsData[0].image.sourceUrl} />
                ) : (
                  <Img
                    fluid={
                      customSolutionsData[0].image.imageFile.childImageSharp
                        .fluid
                    }
                  />
                )}
              </div>
            </div>
            <div class="repeatable-section-content-container">
              <div
                dangerouslySetInnerHTML={{
                  __html: customSolutionsData[0].content,
                }}
              />
              <div style={{ textAlign: "center" }}>
                <div class="repeatable-section-cta-container">
                  <svg
                    class="cta-bg-circle"
                    xmlns="http://www.w3.org/2000/svg"
                    width="79.063"
                    height="71.188"
                    viewBox="0 0 79.063 71.188"
                  >
                    <path
                      id="Shape_5_copy_2"
                      data-name="Shape 5 copy 2"
                      class="cls-1"
                      d="M487.1,573.692c0.067-.016.1-0.01,0,0h0ZM450.031,606.75c0,0.022,0,.032-0.007.054a1,1,0,0,0-.114.1Zm0.422,9c0.008,0.021.014,0.034,0.021,0.053C450.449,615.8,450.427,615.817,450.453,615.75Zm7.971-26.821a0.37,0.37,0,0,1,.108-0.1A1.058,1.058,0,0,0,458.424,588.929Zm44.483-14.648-0.037-.01h0.095Zm-0.165-.082c-0.193-.011.046,0.051,0.128,0.072a2.27,2.27,0,0,1-.633-0.083A3.216,3.216,0,0,1,502.742,574.2ZM527.5,588.745l-0.034-.079A0.585,0.585,0,0,1,527.5,588.745Zm-67.223,2.318,0.088-.085A0.343,0.343,0,0,1,460.277,591.063Zm64.127-5.681,0.025-.083A0.07,0.07,0,0,1,524.4,585.382ZM449.91,606.905l-0.046.062A0.284,0.284,0,0,1,449.91,606.905Zm3.164,17.038a0.127,0.127,0,0,1,.089.014,0.221,0.221,0,0,1,.011.022Zm38.359,20.384a0.1,0.1,0,0,1-.022.04l-0.183-.067A0.88,0.88,0,0,1,491.433,644.327Zm-30.913-10.68a0.155,0.155,0,0,1,0,.055,13.89,13.89,0,0,1-1.063-1.051l0.063-.111Zm12.6,5.163a11.1,11.1,0,0,1-1.248-.326l0.648,0.356,0.636,0.28,1.174,0.5c0.374,0.154.725,0.31,1.076,0.438l1.039,0.335c0.682,0.211,1.334.455,2.04,0.662s1.456,0.411,2.3.684l-0.176-.1c0.254,0.03.414,0.234,1.238,0.423a18.8,18.8,0,0,0,5.113.451v-0.025a1.433,1.433,0,0,0,.578.049c-0.323.027-.646,0.029-0.971,0.044l0.849,0.216a8.808,8.808,0,0,0,1,.128,0.268,0.268,0,0,0,.239-0.106l1.9,0.132,0.573-.169a2.715,2.715,0,0,0,1.876.194c-0.565.245,0.783,0.123,0.6,0.246,0.075-.031.249-0.074,0.386-0.132a24.883,24.883,0,0,1,3.1-.07l-1.878.45c-0.5.118-1.037,0.274-1.511,0.371s-0.885.178-1.129,0.246c1.324-.093.355,0.02,0.1,0.105l-0.094-.056a7.126,7.126,0,0,0-1.185.273,0.087,0.087,0,0,1,.021-0.042l0.053,0.019c0.036-.027.013-0.045-0.031-0.059,0.008-.031-0.03-0.056-0.248-0.041l0.043,0.014c-0.336,0-.914.009-1.167,0l0,0.124a8.266,8.266,0,0,0-2.34-.018,24.9,24.9,0,0,1-2.519.008,5.11,5.11,0,0,1-1.348-.123,13.251,13.251,0,0,0-1.484-.289,4.205,4.205,0,0,0-1.669-.029c-1.018-.187.232-0.087-0.168-0.2l-1.236-.148c0.694,0.2.3,0.171,0.16,0.183-0.523-.127-1.209-0.244-1.8-0.37a2.645,2.645,0,0,1-1.181-.5c-1.413-.358-1.453-0.268-2.049-0.459a2.8,2.8,0,0,0,.642.077c-0.59-.088-0.254-0.115-0.02-0.061-0.412-.165-1.5-0.528-2.526-0.861a4.808,4.808,0,0,1-1.952-.877l-0.023.044c-0.09-.273.291-0.3-0.2-0.676l-0.406-.11-0.506-.359c-0.4-.134-0.246.006-0.258,0.028-0.85-.536-2.064-1.233-3.124-1.838l1.4,0.225a16.008,16.008,0,0,1-1.655-.815,2.986,2.986,0,0,1-.972-0.73l-0.605-.218a2.7,2.7,0,0,1-1.273-.93,0.933,0.933,0,0,0-.414-0.515l-0.905-.525L462.389,635c-0.82-.607-1.217-0.786-1.862-1.292l0-.01a0.184,0.184,0,0,0,.091.051l-0.1-.106a3.232,3.232,0,0,0-.824-1.089,12.169,12.169,0,0,1-.986-1.093,12.881,12.881,0,0,0-1.293-1.42l-0.08-.425a9.078,9.078,0,0,1-.8-0.895l-0.139.088c0.3,0.5.84,1.155,1.386,1.858l0.826,1.06c0.282,0.339.587,0.64,0.847,0.92l-0.038.068a12.725,12.725,0,0,1-.918-1.035c-0.266-.355-0.509-0.679-0.7-0.906-0.207-.205-0.813-0.687-0.564-0.2l-0.219-.529a15.208,15.208,0,0,1-1.031-1.453l-0.693-1.019c-0.469-.613-0.84-1.291-1.663-2.606l0.2,0.2a3.926,3.926,0,0,0-.67-1.213c-0.8-1.648-1.533-3.387-2.052-4.472l0.112-.295c-0.133-.356-0.537-0.851-0.32-1.089l-0.1-.8a11.35,11.35,0,0,0-.283-1.386h0v0c-0.013-.033-0.027-0.068-0.041-0.105a0.027,0.027,0,0,1,.017,0c-0.268-1.13.138-.008-0.132-1.305-0.183-.406.188-0.491,0.074-1.118-0.121-.2-0.212-0.41-0.318-0.618a4.514,4.514,0,0,1-.07-1.317,12.916,12.916,0,0,0,.125-1.695c-0.067-.792-0.258-1.19-0.5-0.668a3.391,3.391,0,0,0,.366-1.278c-0.091-.154-0.121-0.054-0.226.153a3.138,3.138,0,0,1,.216-1.157,1.466,1.466,0,0,0,.58-0.549l0.029,0.249a10.171,10.171,0,0,0,.411-2.13l-0.1.014c0.063-.268.154-0.529,0.23-0.793l-0.108-.073c0.106-.377.2-0.756,0.315-1.129l-0.01.161a12.922,12.922,0,0,0,.473-1.618h-0.071a8.314,8.314,0,0,1,.655-1.965l1.017-2.018-0.223.152c0.124-.564.263-0.07,0.5-0.706l-0.139-.091a1.677,1.677,0,0,0,.428-1.108l0.105,0.254,0.331-.7c0.345-.778.006-0.573-0.158-0.509,0.142-.15.3-0.291,0.452-0.433l-0.111-.178a3.776,3.776,0,0,0,.691-0.968c-0.031-.085-0.167.058-0.06-0.172l0.93-.9-0.522.558,0.293,0.052a8.841,8.841,0,0,0,.952-1.281l-0.3.264a4.409,4.409,0,0,0,.782-1.215c-0.052.151-.133,0.38,0.116,0.11a1.127,1.127,0,0,0,.133-0.38,1.756,1.756,0,0,0,.982-0.886,0.109,0.109,0,0,0-.092.008,1.018,1.018,0,0,0,.336-0.352l-0.263.006c0.159-.092.315-0.185,0.482-0.27a1.7,1.7,0,0,0,.485-0.593l-0.159.116c0.541-.633,1.121-1.235,1.708-1.83l-0.1-.122c0.33-.051.944-0.982,1.086-0.758a4.247,4.247,0,0,1,.767-0.743c0.292-.233.5-0.419,0.279-0.43a13.483,13.483,0,0,1,1.753-1.261c0.289-.186.583-0.382,0.9-0.61s0.677-.468,1.067-0.777A14.1,14.1,0,0,1,470.14,579a52.968,52.968,0,0,1,6.257-2.59c1.3-.834,3.707-1.157,5.262-1.72,0.164,0,.326,0,0.492,0a10.3,10.3,0,0,1,1.948-.507c0.759-.116,1.556-0.282,2.314-0.471,0.4,0,.6-0.013.691-0.021a0.217,0.217,0,0,0-.183.135,3.614,3.614,0,0,0,1.246-.3l-0.118,0c-0.1-.144,1.375-0.075,1.85-0.241l-0.243.183,0.847-.082-0.234-.018c0.471,0.017.907,0.022,1.316,0.019s0.8,0.013,1.163.007l2.058-.032a19.535,19.535,0,0,1,4.36.362c-0.454-.232.682,0.178,0.738,0a5.24,5.24,0,0,1,2.333.476,0.062,0.062,0,0,0,.045.044c0.419,0.058.836,0.134,1.251,0.219-0.705-.4.865,0.391,0.215,0.04a41.152,41.152,0,0,1,10.924,3.717l-0.183-.02c0.45,0.2.923,0.489,1.381,0.738s0.891,0.487,1.237.642a4.071,4.071,0,0,1,.95.618c0.262,0.236.465,0.452,0.582,0.535,0.619,0.525,1.359.79,1.066,0.6,0.693,0.537,1.2,1.178,2.2,1.871a5.458,5.458,0,0,1,1.372,1.169,4.207,4.207,0,0,0,1.125,1.024l-0.007.022a32.155,32.155,0,0,1,3.125,3.427,0.388,0.388,0,0,0-.022-0.086c0.225,0.508.458,1.006,0.663,1.511l0.569,1.519q-0.656-.215-1.3-0.407c-0.7-.666-1.476-1.273-2.221-1.863a33.756,33.756,0,0,0-5.111-5.252,37.666,37.666,0,0,0-5.063-3.1,41.988,41.988,0,0,0-13.537-4.788c-0.332-.117-0.666-0.241-1-0.34-1.421-.047-3.023-0.215-4.663-0.306a25,25,0,0,0-4.806.12l-0.091-.152a2.048,2.048,0,0,0-.984.187,46.813,46.813,0,0,0-11.6,2.449,38.411,38.411,0,0,0-5.272,2.27,32.73,32.73,0,0,0-4.616,2.86,31.435,31.435,0,0,0-2.48,2.077,24.28,24.28,0,0,0-5.1,4.741l0.071-.055-0.714.807c-0.016.044,0,.059,0.033,0.041a16.324,16.324,0,0,0-2.554,3.807l0.063-.065a32.453,32.453,0,0,0-4.362,11.9,25.911,25.911,0,0,0,1.348,12.97q0.342,0.732.664,1.5l0.723,1.546c0.245,0.524.553,1.03,0.826,1.56a16.673,16.673,0,0,0,.887,1.585,26.062,26.062,0,0,0,2.172,3.073,22.228,22.228,0,0,0,2.672,2.8c0.4,0.28,2.531,2.205,4.913,3.873A58.275,58.275,0,0,0,473.116,638.81Zm15.534,4.009-0.042,0C488.612,642.731,488.674,642.766,488.65,642.819Zm-22.665-5.01,0.065,0.038c-0.106-.015-0.2-0.04-0.3-0.064Zm14.074,6.185c-0.68-.151-0.707-0.179-0.6-0.188A3.623,3.623,0,0,1,480.059,643.994Zm13.906-1c0.337-.037.215,0.025,0.022,0.1-0.347.02-.591,0.009-0.591,0.009C493.585,643.07,493.773,643.036,493.965,642.99Zm-1.3,1.2,0.115,0.067C492.576,644.247,492.582,644.221,492.669,644.192Z"
                      transform="translate(-449.656 -573.281)"
                    />
                  </svg>
                  <svg
                    class="cta-side-shape"
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="31"
                    viewBox="0 0 8 31"
                  >
                    <path
                      id="Rectangle_4_copy_14"
                      data-name="Rectangle 4 copy 14"
                      class="cls-1"
                      d="M465,2615h8v1h-8v-1Zm3-5h5v1h-5v-1Zm-3,25h8v1h-8v-1Zm3,5h5v1h-5v-1Zm-3-5h8v1h-8v-1Zm0-20h8v1h-8v-1Zm3,15h5v1h-5v-1Zm-1-5h6v1h-6v-1Zm1-5h5v1h-5v-1Zm-3-5h8v1h-8v-1Zm3-5h5v1h-5v-1Z"
                      transform="translate(-465 -2610)"
                    />
                  </svg>
                  <Link class="cta" to={customSolutionsData[0].link.url}>
                    {customSolutionsData[0].link.title}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {customSolutionsData.slice(1).map((item, index) => {
        let Image
        if (5 % index === 0) {
          Image = (
            <Img
              className="bg-image-fit"
              fluid={customSolutionsBg.childImageSharp.fluid}
            />
          )
        } else {
          if (index % 2 === 0) {
            Image = (
              <Img
                className="bg-image-fit"
                fluid={section1Bg.childImageSharp.fluid}
              />
            )
          } else {
            Image = (
              <Img
                className="bg-image-fit"
                fluid={section2Bg.childImageSharp.fluid}
              />
            )
          }
        }

        return (
          <>
            <section class="repeatable-section-bg">
              {Image}
              <Fade>
                <div class="repeatable-section-container-container">
                  <div class="repeatable-section-title-container">
                    <svg
                      class="repeatable-section-rectangle"
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="159"
                      viewBox="0 0 23 159"
                    >
                      <rect class="cls-1" width="23" height="159" />
                    </svg>
                    <h2>{item.title}</h2>
                    <svg
                      class="repeatable-section-title-shape"
                      xmlns="http://www.w3.org/2000/svg"
                      width="91"
                      height="8"
                      viewBox="0 0 91 8"
                    >
                      <path
                        id="Rectangle_4_copy_13"
                        data-name="Rectangle 4 copy 13"
                        class="cls-1"
                        d="M410,1912h1v8h-1v-8Zm5,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm-50-2h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm5-3h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm45-3h1v8h-1v-8Zm5,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm-50-2h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Zm5-3h1v8h-1v-8Zm20,0h1v8h-1v-8Zm-15,3h1v5h-1v-5Zm5-1h1v6h-1v-6Zm5,1h1v5h-1v-5Z"
                        transform="translate(-370 -1912)"
                      />
                    </svg>
                  </div>
                  <div class="repeatable-section-container">
                    <div>
                      <div class="repeatable-image-container">
                        {previewData ? (
                          <img src={item.image.sourceUrl} />
                        ) : (
                          <Img
                            fluid={item.image.imageFile.childImageSharp.fluid}
                          />
                        )}
                      </div>
                    </div>
                    <div class="repeatable-section-content-container">
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                      <div style={{ textAlign: "center" }}>
                        <div class="repeatable-section-cta-container">
                          <svg
                            class="cta-bg-circle"
                            xmlns="http://www.w3.org/2000/svg"
                            width="79.063"
                            height="71.188"
                            viewBox="0 0 79.063 71.188"
                          >
                            <path
                              id="Shape_5_copy_2"
                              data-name="Shape 5 copy 2"
                              class="cls-1"
                              d="M487.1,573.692c0.067-.016.1-0.01,0,0h0ZM450.031,606.75c0,0.022,0,.032-0.007.054a1,1,0,0,0-.114.1Zm0.422,9c0.008,0.021.014,0.034,0.021,0.053C450.449,615.8,450.427,615.817,450.453,615.75Zm7.971-26.821a0.37,0.37,0,0,1,.108-0.1A1.058,1.058,0,0,0,458.424,588.929Zm44.483-14.648-0.037-.01h0.095Zm-0.165-.082c-0.193-.011.046,0.051,0.128,0.072a2.27,2.27,0,0,1-.633-0.083A3.216,3.216,0,0,1,502.742,574.2ZM527.5,588.745l-0.034-.079A0.585,0.585,0,0,1,527.5,588.745Zm-67.223,2.318,0.088-.085A0.343,0.343,0,0,1,460.277,591.063Zm64.127-5.681,0.025-.083A0.07,0.07,0,0,1,524.4,585.382ZM449.91,606.905l-0.046.062A0.284,0.284,0,0,1,449.91,606.905Zm3.164,17.038a0.127,0.127,0,0,1,.089.014,0.221,0.221,0,0,1,.011.022Zm38.359,20.384a0.1,0.1,0,0,1-.022.04l-0.183-.067A0.88,0.88,0,0,1,491.433,644.327Zm-30.913-10.68a0.155,0.155,0,0,1,0,.055,13.89,13.89,0,0,1-1.063-1.051l0.063-.111Zm12.6,5.163a11.1,11.1,0,0,1-1.248-.326l0.648,0.356,0.636,0.28,1.174,0.5c0.374,0.154.725,0.31,1.076,0.438l1.039,0.335c0.682,0.211,1.334.455,2.04,0.662s1.456,0.411,2.3.684l-0.176-.1c0.254,0.03.414,0.234,1.238,0.423a18.8,18.8,0,0,0,5.113.451v-0.025a1.433,1.433,0,0,0,.578.049c-0.323.027-.646,0.029-0.971,0.044l0.849,0.216a8.808,8.808,0,0,0,1,.128,0.268,0.268,0,0,0,.239-0.106l1.9,0.132,0.573-.169a2.715,2.715,0,0,0,1.876.194c-0.565.245,0.783,0.123,0.6,0.246,0.075-.031.249-0.074,0.386-0.132a24.883,24.883,0,0,1,3.1-.07l-1.878.45c-0.5.118-1.037,0.274-1.511,0.371s-0.885.178-1.129,0.246c1.324-.093.355,0.02,0.1,0.105l-0.094-.056a7.126,7.126,0,0,0-1.185.273,0.087,0.087,0,0,1,.021-0.042l0.053,0.019c0.036-.027.013-0.045-0.031-0.059,0.008-.031-0.03-0.056-0.248-0.041l0.043,0.014c-0.336,0-.914.009-1.167,0l0,0.124a8.266,8.266,0,0,0-2.34-.018,24.9,24.9,0,0,1-2.519.008,5.11,5.11,0,0,1-1.348-.123,13.251,13.251,0,0,0-1.484-.289,4.205,4.205,0,0,0-1.669-.029c-1.018-.187.232-0.087-0.168-0.2l-1.236-.148c0.694,0.2.3,0.171,0.16,0.183-0.523-.127-1.209-0.244-1.8-0.37a2.645,2.645,0,0,1-1.181-.5c-1.413-.358-1.453-0.268-2.049-0.459a2.8,2.8,0,0,0,.642.077c-0.59-.088-0.254-0.115-0.02-0.061-0.412-.165-1.5-0.528-2.526-0.861a4.808,4.808,0,0,1-1.952-.877l-0.023.044c-0.09-.273.291-0.3-0.2-0.676l-0.406-.11-0.506-.359c-0.4-.134-0.246.006-0.258,0.028-0.85-.536-2.064-1.233-3.124-1.838l1.4,0.225a16.008,16.008,0,0,1-1.655-.815,2.986,2.986,0,0,1-.972-0.73l-0.605-.218a2.7,2.7,0,0,1-1.273-.93,0.933,0.933,0,0,0-.414-0.515l-0.905-.525L462.389,635c-0.82-.607-1.217-0.786-1.862-1.292l0-.01a0.184,0.184,0,0,0,.091.051l-0.1-.106a3.232,3.232,0,0,0-.824-1.089,12.169,12.169,0,0,1-.986-1.093,12.881,12.881,0,0,0-1.293-1.42l-0.08-.425a9.078,9.078,0,0,1-.8-0.895l-0.139.088c0.3,0.5.84,1.155,1.386,1.858l0.826,1.06c0.282,0.339.587,0.64,0.847,0.92l-0.038.068a12.725,12.725,0,0,1-.918-1.035c-0.266-.355-0.509-0.679-0.7-0.906-0.207-.205-0.813-0.687-0.564-0.2l-0.219-.529a15.208,15.208,0,0,1-1.031-1.453l-0.693-1.019c-0.469-.613-0.84-1.291-1.663-2.606l0.2,0.2a3.926,3.926,0,0,0-.67-1.213c-0.8-1.648-1.533-3.387-2.052-4.472l0.112-.295c-0.133-.356-0.537-0.851-0.32-1.089l-0.1-.8a11.35,11.35,0,0,0-.283-1.386h0v0c-0.013-.033-0.027-0.068-0.041-0.105a0.027,0.027,0,0,1,.017,0c-0.268-1.13.138-.008-0.132-1.305-0.183-.406.188-0.491,0.074-1.118-0.121-.2-0.212-0.41-0.318-0.618a4.514,4.514,0,0,1-.07-1.317,12.916,12.916,0,0,0,.125-1.695c-0.067-.792-0.258-1.19-0.5-0.668a3.391,3.391,0,0,0,.366-1.278c-0.091-.154-0.121-0.054-0.226.153a3.138,3.138,0,0,1,.216-1.157,1.466,1.466,0,0,0,.58-0.549l0.029,0.249a10.171,10.171,0,0,0,.411-2.13l-0.1.014c0.063-.268.154-0.529,0.23-0.793l-0.108-.073c0.106-.377.2-0.756,0.315-1.129l-0.01.161a12.922,12.922,0,0,0,.473-1.618h-0.071a8.314,8.314,0,0,1,.655-1.965l1.017-2.018-0.223.152c0.124-.564.263-0.07,0.5-0.706l-0.139-.091a1.677,1.677,0,0,0,.428-1.108l0.105,0.254,0.331-.7c0.345-.778.006-0.573-0.158-0.509,0.142-.15.3-0.291,0.452-0.433l-0.111-.178a3.776,3.776,0,0,0,.691-0.968c-0.031-.085-0.167.058-0.06-0.172l0.93-.9-0.522.558,0.293,0.052a8.841,8.841,0,0,0,.952-1.281l-0.3.264a4.409,4.409,0,0,0,.782-1.215c-0.052.151-.133,0.38,0.116,0.11a1.127,1.127,0,0,0,.133-0.38,1.756,1.756,0,0,0,.982-0.886,0.109,0.109,0,0,0-.092.008,1.018,1.018,0,0,0,.336-0.352l-0.263.006c0.159-.092.315-0.185,0.482-0.27a1.7,1.7,0,0,0,.485-0.593l-0.159.116c0.541-.633,1.121-1.235,1.708-1.83l-0.1-.122c0.33-.051.944-0.982,1.086-0.758a4.247,4.247,0,0,1,.767-0.743c0.292-.233.5-0.419,0.279-0.43a13.483,13.483,0,0,1,1.753-1.261c0.289-.186.583-0.382,0.9-0.61s0.677-.468,1.067-0.777A14.1,14.1,0,0,1,470.14,579a52.968,52.968,0,0,1,6.257-2.59c1.3-.834,3.707-1.157,5.262-1.72,0.164,0,.326,0,0.492,0a10.3,10.3,0,0,1,1.948-.507c0.759-.116,1.556-0.282,2.314-0.471,0.4,0,.6-0.013.691-0.021a0.217,0.217,0,0,0-.183.135,3.614,3.614,0,0,0,1.246-.3l-0.118,0c-0.1-.144,1.375-0.075,1.85-0.241l-0.243.183,0.847-.082-0.234-.018c0.471,0.017.907,0.022,1.316,0.019s0.8,0.013,1.163.007l2.058-.032a19.535,19.535,0,0,1,4.36.362c-0.454-.232.682,0.178,0.738,0a5.24,5.24,0,0,1,2.333.476,0.062,0.062,0,0,0,.045.044c0.419,0.058.836,0.134,1.251,0.219-0.705-.4.865,0.391,0.215,0.04a41.152,41.152,0,0,1,10.924,3.717l-0.183-.02c0.45,0.2.923,0.489,1.381,0.738s0.891,0.487,1.237.642a4.071,4.071,0,0,1,.95.618c0.262,0.236.465,0.452,0.582,0.535,0.619,0.525,1.359.79,1.066,0.6,0.693,0.537,1.2,1.178,2.2,1.871a5.458,5.458,0,0,1,1.372,1.169,4.207,4.207,0,0,0,1.125,1.024l-0.007.022a32.155,32.155,0,0,1,3.125,3.427,0.388,0.388,0,0,0-.022-0.086c0.225,0.508.458,1.006,0.663,1.511l0.569,1.519q-0.656-.215-1.3-0.407c-0.7-.666-1.476-1.273-2.221-1.863a33.756,33.756,0,0,0-5.111-5.252,37.666,37.666,0,0,0-5.063-3.1,41.988,41.988,0,0,0-13.537-4.788c-0.332-.117-0.666-0.241-1-0.34-1.421-.047-3.023-0.215-4.663-0.306a25,25,0,0,0-4.806.12l-0.091-.152a2.048,2.048,0,0,0-.984.187,46.813,46.813,0,0,0-11.6,2.449,38.411,38.411,0,0,0-5.272,2.27,32.73,32.73,0,0,0-4.616,2.86,31.435,31.435,0,0,0-2.48,2.077,24.28,24.28,0,0,0-5.1,4.741l0.071-.055-0.714.807c-0.016.044,0,.059,0.033,0.041a16.324,16.324,0,0,0-2.554,3.807l0.063-.065a32.453,32.453,0,0,0-4.362,11.9,25.911,25.911,0,0,0,1.348,12.97q0.342,0.732.664,1.5l0.723,1.546c0.245,0.524.553,1.03,0.826,1.56a16.673,16.673,0,0,0,.887,1.585,26.062,26.062,0,0,0,2.172,3.073,22.228,22.228,0,0,0,2.672,2.8c0.4,0.28,2.531,2.205,4.913,3.873A58.275,58.275,0,0,0,473.116,638.81Zm15.534,4.009-0.042,0C488.612,642.731,488.674,642.766,488.65,642.819Zm-22.665-5.01,0.065,0.038c-0.106-.015-0.2-0.04-0.3-0.064Zm14.074,6.185c-0.68-.151-0.707-0.179-0.6-0.188A3.623,3.623,0,0,1,480.059,643.994Zm13.906-1c0.337-.037.215,0.025,0.022,0.1-0.347.02-.591,0.009-0.591,0.009C493.585,643.07,493.773,643.036,493.965,642.99Zm-1.3,1.2,0.115,0.067C492.576,644.247,492.582,644.221,492.669,644.192Z"
                              transform="translate(-449.656 -573.281)"
                            />
                          </svg>
                          <svg
                            class="cta-side-shape"
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="31"
                            viewBox="0 0 8 31"
                          >
                            <path
                              id="Rectangle_4_copy_14"
                              data-name="Rectangle 4 copy 14"
                              class="cls-1"
                              d="M465,2615h8v1h-8v-1Zm3-5h5v1h-5v-1Zm-3,25h8v1h-8v-1Zm3,5h5v1h-5v-1Zm-3-5h8v1h-8v-1Zm0-20h8v1h-8v-1Zm3,15h5v1h-5v-1Zm-1-5h6v1h-6v-1Zm1-5h5v1h-5v-1Zm-3-5h8v1h-8v-1Zm3-5h5v1h-5v-1Z"
                              transform="translate(-465 -2610)"
                            />
                          </svg>
                          <Link class="cta" href={item.link.url}>
                            {item.link.title}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </section>
          </>
        )
      })}

      <div class="custom-solutions-conclusion-container">
        <div class="custom-solutions-conclusion-content">
          <div dangerouslySetInnerHTML={{ __html: closingContent }} />
        </div>
      </div>
    </Layout>
  )
}

export default CustomSolutions
